
import { $color } from "@/utils/cssVarUtils"
import { cssVar, SystemStyleFunction } from "@chakra-ui/theme-tools"

const $bg = cssVar("tooltip-bg")
const $arrowBg = cssVar("popper-arrow-bg")

const baseStyle: SystemStyleFunction = (props) => {
  return {
    [$bg.variable]: $color('bg-tooltip-accent'),
    px: "0.666667em",
    py: "0.333333em",
    bg: [$bg.reference],
    [$arrowBg.variable]: $color('bg-tooltip-accent'),
    color: 'text.normal',
    borderRadius: "0.333333em",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: 'normal',
    maxW: "container.md",
    zIndex: "tooltip",
  }
}

export const Tooltip = {
  baseStyle,
}